module.exports = __webpack_public_path__ + "img/icons.4729eb12.svg";